module.exports = __webpack_public_path__ + "static/img/b6.b510dc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/b6.png
// module id = Q13g
// module chunks = 0